/**
 * 商城「選單設定」→「套用預設選單」建議項目。
 * 路徑與 docs/development/商城前台設計模板開發規範.md 之典型路由對齊（首頁／購物車／會員等）。
 */
export function createDefaultCommerceMenuItems() {
  return [
    { label: '首頁', type: 'url', href: '/', openInNewTab: false },
    { label: '全部商品', type: 'url', href: '/products', openInNewTab: false },
    { label: '購物車', type: 'url', href: '/cart', openInNewTab: false },
    { label: '會員中心', type: 'url', href: '/account/profile', openInNewTab: false },
  ].map((item) => ({ ...item, position: 'main' }))
}
